import React, { useCallback, useLayoutEffect } from 'react'
import { useTranslations } from 'next-intl'
import { SquareSplitHorizontalIcon } from '@phosphor-icons/react/dist/ssr/SquareSplitHorizontal'
import { Button } from '@skop-app/lib-front'
import { cx } from 'class-variance-authority'

import { useGridApi, useGridViews } from './GridRoot'
import { GRID_TOOLBAR_CONTROL_CLASSNAME } from './toolbarControlStyles'
import { usePreventGridFocusSteal } from './usePreventGridFocusSteal'
import type { GridColumnsButtonProps } from '../types'

export function GridColumnsButton({
  className,
  label,
  title,
  disabled,
}: GridColumnsButtonProps) {
  const t = useTranslations()
  const { api, gridIsReady, requestColumnsPanel } = useGridApi()
  const views = useGridViews()

  useLayoutEffect(() => {
    requestColumnsPanel()
  }, [requestColumnsPanel])

  const handleClick = useCallback(() => {
    if (!api || !gridIsReady || views?.isInteractionBlocked === true) return
    const isVisible = api.isSideBarVisible()
    api.setSideBarVisible(!isVisible)
    if (!isVisible) {
      api.openToolPanel('columns')
    }
  }, [api, gridIsReady, views?.isInteractionBlocked])

  const labelText = label ?? t('Toolbar.columns')
  const titleText = title ?? labelText
  const isDisabled =
    views?.isInteractionBlocked === true || (disabled ?? !gridIsReady)
  const preventFocusSteal = usePreventGridFocusSteal()

  return (
    <Button
      variant="action"
      onMouseDown={preventFocusSteal}
      onClick={handleClick}
      title={titleText}
      className={cx(GRID_TOOLBAR_CONTROL_CLASSNAME, 'gap-0.5', className)}
      disabled={isDisabled}
    >
      <SquareSplitHorizontalIcon className="size-5 shrink-0" />
      <span className="hidden xl:block">{labelText}</span>
    </Button>
  )
}
